import { Link, usePage } from '@inertiajs/react'
import { toPng } from 'html-to-image'
import { Download, Menu } from 'lucide-react'
import { type PropsWithChildren, useEffect, useRef, useState } from 'react'
import baselineLogo from '@/assets/baseline.png'
import pwcLogo from '@/assets/pwc.png'

// Sponsors - Don vi to chuc
import sponsorPwc from '@/assets/sponsors/don-vi-to-chuc/1pwc.png'
import sponsorVinama from '@/assets/sponsors/don-vi-to-chuc/2vinama.png'
import sponsorCasa from '@/assets/sponsors/don-vi-to-chuc/3logo-casa.jpg'
// Sponsors - Don vi doi tac cong nghe
import sponsorBaseline from '@/assets/sponsors/don-vi-doi-tac-cong-nghe/1baseline.png'
// Sponsors - Don vi tai tro
import sponsorJoola from '@/assets/sponsors/don-vi-tai-tro/1joola.png'
import sponsorMancode from '@/assets/sponsors/don-vi-tai-tro/0mancode.png'
import sponsorPickoinn from '@/assets/sponsors/don-vi-tai-tro/2pickoinn.jpg'
import sponsorCoolmate from '@/assets/sponsors/don-vi-tai-tro/3coolmate.png'
import sponsorWiki from '@/assets/sponsors/don-vi-tai-tro/4wiki.png'
import sponsorFacolos from '@/assets/sponsors/don-vi-tai-tro/5facolos.jpg'
import sponsorSoxter from '@/assets/sponsors/don-vi-tai-tro/6soxter.jpg'
import sponsorKaiwin from '@/assets/sponsors/don-vi-tai-tro/7kaiwin.jpg'
// Sponsors - Don vi phoi hop bao tro
import sponsorHtpf from '@/assets/sponsors/don-vi-phoi-hop-bao-tro/1htpf.png'
import sponsorUpa from '@/assets/sponsors/don-vi-phoi-hop-bao-tro/2upa.png'
// Sponsors - Don vi dang cai dia diem
import sponsorLachateau from '@/assets/sponsors/don-vi-dang-cai-dia-diem-to-chuc/1LACHATEAU.png'
// Sponsors - Don vi dong hanh
import sponsorHoon from '@/assets/sponsors/don-vi-dong-hanh/1hoon.png'
import sponsorPrimeSteak from '@/assets/sponsors/don-vi-dong-hanh/2prime.png'
import sponsorDieuTamHuong from '@/assets/sponsors/don-vi-dong-hanh/4dieu-tam-huong.png'
import sponsorLuzz from '@/assets/sponsors/don-vi-dong-hanh/5luzz.png'
import sponsorFor from '@/assets/sponsors/don-vi-dong-hanh/6for.jpg'
import sponsorAlphaPlus from '@/assets/sponsors/don-vi-dong-hanh/alpha-plus.png'
import sponsorFordSuoiTien from '@/assets/sponsors/don-vi-dong-hanh/ford-suoitien.png'
import sponsorTechbeat from '@/assets/sponsors/don-vi-dong-hanh/techbeat.png'
import sponsorSoma from '@/assets/sponsors/don-vi-dong-hanh/soma.png'
import sponsorLotto from '@/assets/sponsors/don-vi-dong-hanh/lotto.png'
import sponsorLekofe from '@/assets/sponsors/don-vi-dong-hanh/lekofe.png'
// Sponsors - Don vi bao tro truyen thong
import sponsorPvna from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/1pvna.png'
import sponsorVtvcab from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/2vtvcab.png'
import sponsorFocusMedia from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/focus-media.png'
import sponsorFamily from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/4family.png'
import sponsor24h from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/424h.png'
import sponsorFpt from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/5fpt.png'
import sponsorDeer from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/6deer.png'
import sponsorUpnity from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/7upnity.png'
import sponsorRadiant from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/8radiant.png'
import sponsorTamsu from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/9tamsu.png'
import sponsorVui from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/10vui.png'
import sponsorCongdong from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/11congdong.png'
import sponsorTa from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/12ta.png'
import sponsorLaomo from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/13laomo.png'
import sponsorWowsport from '@/assets/sponsors/don-vi-bao-tro-truyen-thong/14wowsport.png'
// Sponsors - Don vi sale
import sponsorAquarius from '@/assets/sponsors/don-vi-sale/1aquarius.png'

const sponsorSections = {
  toChuc: {
    title: 'ĐƠN VỊ TỔ CHỨC',
    logoHeight: 'h-10 sm:h-12',
    logos: [
      { src: sponsorPwc, alt: 'Pickleball World Communications' },
      { src: sponsorVinama, alt: 'Vinama' },
      { src: sponsorCasa, alt: 'Casa' },
    ],
  },
  phoiHopBaoTro: {
    title: 'PHỐI HỢP BẢO TRỢ',
    logoHeight: 'h-10 sm:h-12',
    logos: [
      { src: sponsorHtpf, alt: 'HTPF' },
      { src: sponsorUpa, alt: 'UPA Asia' },
    ],
  },
  dangCai: {
    title: 'ĐƠN VỊ ĐĂNG CAI ĐỊA ĐIỂM TỔ CHỨC',
    logoHeight: 'h-24 sm:h-28',
    logos: [
      { src: sponsorLachateau, alt: 'Lachateau Hotel' },
    ],
  },
  taiTro: {
    title: 'ĐƠN VỊ TÀI TRỢ',
    logoHeight: 'h-10 sm:h-12',
    logos: [
      { src: sponsorJoola, alt: 'Joola' },
      { src: sponsorLuzz, alt: 'Luzz Pickleball' },
      { src: sponsorMancode, alt: 'Mancode' },
      { src: sponsorPickoinn, alt: 'Pickoinn' },
      { src: sponsorWiki, alt: 'Wika' },
      { src: sponsorCoolmate, alt: 'Coolmate' },
      { src: sponsorKaiwin, alt: 'Kaiwin' },
      { src: sponsorSoxter, alt: 'Soxter' },
      { src: sponsorFacolos, alt: 'Facolos' },
    ],
  },
  congNghe: {
    title: 'ĐỐI TÁC CÔNG NGHỆ',
    logoHeight: 'h-8 sm:h-10',
    logos: [
      { src: sponsorBaseline, alt: 'Baseline' },
    ],
  },
  phatSongTrucTiep: {
    title: 'ĐƠN VỊ SẢN XUẤT PHÁT SÓNG',
    logoHeight: 'h-10 sm:h-12',
    logos: [
      { src: sponsorFpt, alt: 'FPT Play' },
    ],
  },
  baoTroTruyenThong: {
    title: 'BẢO TRỢ TRUYỀN THÔNG',
    logoHeight: 'h-10 sm:h-12',
    logos: [
      { src: sponsorFpt, alt: 'FPT Play' },
      { src: sponsorVtvcab, alt: 'VTVcab' },
      { src: sponsorFocusMedia, alt: 'Focus Media' },
      { src: sponsorFamily, alt: 'aFamily' },
      { src: sponsor24h, alt: '24h.com.vn' },
      { src: sponsorDeer, alt: 'House of Deera' },
      { src: sponsorUpnity, alt: 'Upnity' },
      { src: sponsorRadiant, alt: 'Radiant Vietnam' },
      { src: sponsorTamsu, alt: 'Tam Su Pickleball' },
      { src: sponsorVui, alt: 'Pickleball Co Gi Vui' },
      { src: sponsorCongdong, alt: 'Cong Dong Pickleball Viet Nam' },
      { src: sponsorTa, alt: 'TA Pickleball' },
      { src: sponsorLaomo, alt: 'Laomo Sports Live' },
      { src: sponsorWowsport, alt: 'Wow Sport' },
      { src: sponsorPvna, alt: 'Pickleball VNA' },
    ],
  },
  dongHanh: {
    title: 'ĐƠN VỊ ĐỒNG HÀNH',
    logoHeight: 'h-12 sm:h-16',
    logos: [
      { src: sponsorHoon, alt: 'Hoon Wedding' },
      { src: sponsorPrimeSteak, alt: 'Prime Steak' },
      { src: sponsorDieuTamHuong, alt: 'Diệu Tâm Hương' },
      { src: sponsorFor, alt: 'For' },
      { src: sponsorLotto, alt: 'Lotto' },
      { src: sponsorTechbeat, alt: 'Techbeat' },
      { src: sponsorLekofe, alt: 'Lekofe' },
      { src: sponsorAlphaPlus, alt: 'Alpha Plus' },
      { src: sponsorFordSuoiTien, alt: 'Ford Suối Tiên' },
      { src: sponsorSoma, alt: 'Soma' },
    ],
  },
  phuTrachTaiTro: {
    title: 'ĐƠN VỊ PHỤ TRÁCH TÀI TRỢ',
    logoHeight: 'h-16 sm:h-20',
    logos: [
      { src: sponsorAquarius, alt: 'Aquarius' },
    ],
  },
}

type SiteLayoutProps = PropsWithChildren

const navItems = [
  { label: 'Trang chủ', href: '/' },
  { label: 'Bảng xếp hạng', href: '/bang-xep-hang' },
  { label: 'Hạng mục', href: '/categories' },
  { label: 'Bình chọn', href: '/binh-chon' },
  { label: 'Hội đồng', href: '/council' },
  { label: 'Điều lệ', href: '/dieu-le' },
]

export function SiteLayout({ children }: SiteLayoutProps) {
  const { url } = usePage()
  const currentPath = url.split('?')[0]
  const [animationKey, setAnimationKey] = useState(0)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const sponsorRef = useRef<HTMLElement>(null)

  const exportBtnRef = useRef<HTMLButtonElement>(null)

  const captureSponsorSection = async () => {
    const el = sponsorRef.current
    if (!el) return
    const btn = exportBtnRef.current
    if (btn) btn.style.display = 'none'
    try {
      const dataUrl = await toPng(el, { pixelRatio: 2 })
      const link = document.createElement('a')
      link.download = 'sponsors.png'
      link.href = dataUrl
      link.click()
    } finally {
      if (btn) btn.style.display = ''
    }
  }

  const isActive = (href: string) =>
    href === '/' ? currentPath === href : currentPath.startsWith(href)

  useEffect(() => {
    setAnimationKey((prev) => prev + 1)
  }, [])

  return (
    <div className="relative flex min-h-svh flex-col overflow-hidden bg-[#f3f6f9] text-[#042133]">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.95),rgba(240,246,250,0.9),rgba(224,234,242,0.85))]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-30 mask-[radial-gradient(50%_35%_at_50%_15%,black,transparent)] bg-[repeating-conic-gradient(from_0deg,rgba(4,33,51,0.06)_0deg,rgba(4,33,51,0.06)_8deg,transparent_8deg,transparent_16deg)]"
      />

      <header className="relative z-10">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6 sm:py-6">
          <Link href="/" className="flex items-center gap-2 sm:gap-3">
            <img
              src={pwcLogo}
              alt="PwC"
              className="h-9 w-9 rounded-full object-contain sm:h-11 sm:w-11"
            />
            <div>
              <p className="text-[9px] uppercase tracking-[0.3em] text-[#456477] sm:text-[10px]">
                Vietnam Pickleball Awards
              </p>
              <p className="text-lg font-semibold tracking-tight sm:text-xl">2025</p>
            </div>
          </Link>
          <nav className="hidden items-center gap-8 text-[11px] uppercase tracking-[0.25em] text-[#5b7788] lg:flex">
            {navItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className={
                  isActive(item.href)
                    ? 'group relative text-[#042133]'
                    : 'group relative text-[#5b7788] transition-colors hover:text-[#042133]'
                }
                aria-current={isActive(item.href) ? 'page' : undefined}
              >
                {item.label}
                <span
                  className={
                    isActive(item.href)
                      ? 'absolute -bottom-2 left-0 h-0.5 w-full origin-left scale-x-100 rounded-full bg-[#FCC632] transition-transform duration-300'
                      : 'absolute -bottom-2 left-0 h-0.5 w-full origin-left scale-x-0 rounded-full bg-[#FCC632] transition-transform duration-300 group-hover:scale-x-100'
                  }
                />
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <button
              type="button"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[#042133]/15 text-[#042133] transition hover:bg-white/80 lg:hidden"
              aria-label="Mở меню"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((prev) => !prev)}
            >
              <Menu className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      {isMenuOpen && (
        <div className="fixed inset-0 z-20 flex items-center justify-center px-4 lg:hidden">
          <button
            type="button"
            aria-label="Đóng меню"
            className="absolute inset-0 bg-[#042133]/35 animate-menu-fade"
            onClick={() => setIsMenuOpen(false)}
          />
          <div className="relative w-full max-w-sm rounded-2xl border border-[#042133]/10 bg-white/95 p-5 shadow-[0_24px_70px_-50px_rgba(4,33,51,0.4)] animate-menu-panel">
            <nav className="flex flex-col items-center gap-4 text-sm uppercase tracking-[0.25em] text-[#5b7788]">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className={isActive(item.href) ? 'text-[#042133]' : 'hover:text-[#042133]'}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}

      <main className="relative z-10 flex-1">
        <div key={animationKey} className="page-enter">
          {children}
        </div>
      </main>
      <section ref={sponsorRef} className="relative z-10 bg-[#1a1a1a] py-12 sm:py-16">
        {import.meta.env.DEV && (
          <button
            ref={exportBtnRef}
            type="button"
            onClick={captureSponsorSection}
            className="absolute right-4 top-4 z-50 flex items-center gap-1.5 rounded bg-white/10 px-3 py-1.5 text-xs text-white/60 hover:bg-white/20"
          >
            <Download className="h-3 w-3" />
            Export PNG
          </button>
        )}
        <div className="mx-auto max-w-6xl px-4 sm:px-6">

          {/* Row 1: Tổ chức + Phối hợp bảo trợ */}
          <div className="grid grid-cols-1 gap-10 sm:gap-12 md:grid-cols-2">
            {[sponsorSections.toChuc, sponsorSections.phoiHopBaoTro].map((section) => (
              <div key={section.title} className="text-center">
                <h3 className="mb-6 text-[11px] uppercase tracking-[0.3em] text-[#c8a84e] sm:text-xs">
                  {section.title}
                </h3>
                <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
                  {section.logos.map((logo) => (
                    <img
                      key={logo.alt}
                      src={logo.src}
                      alt={logo.alt}
                      className={`${section.logoHeight} w-auto min-w-0 max-w-[140px] object-contain`}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Row 2: Phát sóng trực tiếp + Công nghệ */}
          <div className="mt-10 grid grid-cols-1 gap-10 sm:mt-12 sm:gap-12 md:grid-cols-2">
            {[sponsorSections.congNghe, sponsorSections.phatSongTrucTiep].map((section) => (
              <div key={section.title} className="text-center">
                <h3 className="mb-6 text-[11px] uppercase tracking-[0.3em] text-[#c8a84e] sm:text-xs">
                  {section.title}
                </h3>
                <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8">
                  {section.logos.map((logo) => (
                    <img
                      key={logo.alt}
                      src={logo.src}
                      alt={logo.alt}
                      className={`${section.logoHeight} w-auto object-contain`}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Row 3: Đăng cai địa điểm */}
          {sponsorSections.dangCai.logos.length > 0 && (
            <div className="mt-10 sm:mt-12">
              <div className="text-center">
                <h3 className="mb-6 text-[11px] uppercase tracking-[0.3em] text-[#c8a84e] sm:text-xs">
                  {sponsorSections.dangCai.title}
                </h3>
                <div className="flex items-center justify-center gap-6 sm:gap-8">
                  {sponsorSections.dangCai.logos.map((logo) => (
                    <img
                      key={logo.alt}
                      src={logo.src}
                      alt={logo.alt}
                      className={`${sponsorSections.dangCai.logoHeight} w-auto object-contain`}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Row 4: Tài trợ */}
          <div className="mt-10 sm:mt-12">
            <div className="text-center">
              <h3 className="mb-6 text-[11px] uppercase tracking-[0.3em] text-[#c8a84e] sm:text-xs">
                {sponsorSections.taiTro.title}
              </h3>
              <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
                {sponsorSections.taiTro.logos.map((logo) => (
                  <img
                    key={logo.alt}
                    src={logo.src}
                    alt={logo.alt}
                    className="h-10 w-auto max-w-[140px] object-contain sm:h-12"
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Row 5: Bảo trợ truyền thông */}
          <div className="mt-10 sm:mt-12">
            <div className="text-center">
              <h3 className="mb-6 text-center text-[11px] uppercase tracking-[0.3em] text-[#c8a84e] sm:text-xs">
                {sponsorSections.baoTroTruyenThong.title}
              </h3>
              <div className="flex flex-wrap items-center justify-center gap-5 sm:gap-8">
                {sponsorSections.baoTroTruyenThong.logos.map((logo) => (
                  <img
                    key={logo.alt}
                    src={logo.src}
                    alt={logo.alt}
                    className={`${sponsorSections.baoTroTruyenThong.logoHeight} w-auto object-contain`}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Row 6: Đồng hành + Phụ trách tài trợ */}
          <div className="mt-10 grid grid-cols-1 gap-10 sm:mt-12 sm:gap-12 md:grid-cols-[1fr_auto]">
            {sponsorSections.dongHanh.logos.length > 0 && (
              <div className="text-center">
                <h3 className="mb-6 text-center text-[11px] uppercase tracking-[0.3em] text-[#c8a84e] sm:text-xs">
                  {sponsorSections.dongHanh.title}
                </h3>
                <div className="flex flex-wrap items-center justify-center gap-5">
                  {sponsorSections.dongHanh.logos.map((logo) => (
                    <img
                      key={logo.alt}
                      src={logo.src}
                      alt={logo.alt}
                      className={`${sponsorSections.dongHanh.logoHeight} w-auto max-w-full object-contain`}
                    />
                  ))}
                </div>
              </div>
            )}
            <div className="text-center md:w-48">
              <h3 className="mb-6 text-center text-[11px] uppercase tracking-[0.3em] text-[#c8a84e] sm:text-xs">
                {sponsorSections.phuTrachTaiTro.title}
              </h3>
              <div className="flex flex-wrap items-center justify-center gap-5 sm:gap-8">
                {sponsorSections.phuTrachTaiTro.logos.map((logo) => (
                  <img
                    key={logo.alt}
                    src={logo.src}
                    alt={logo.alt}
                    className={`${sponsorSections.phuTrachTaiTro.logoHeight} w-auto object-contain`}
                  />
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>

      <footer className="relative z-10">
        <div className="bg-[#111] py-8 sm:py-10">
          <div className="mx-auto flex max-w-6xl flex-col items-center gap-5 px-4 sm:flex-row sm:justify-center sm:gap-10 sm:px-6">
            <a
              href="tel:0906815152"
              className="inline-flex items-center gap-2 text-sm tracking-wide text-[#c8a84e] transition hover:text-white"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              Hotline: 0906.81.51.52 — Mr Đoàn Ngọc Minh (Trưởng BTC)
            </a>
            <a
              href="https://www.facebook.com/vnpickleball.awards"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm tracking-wide text-[#c8a84e] transition hover:text-white"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              Fanpage Vietnam Pickleball Awards
            </a>
          </div>
        </div>
        <div className="mx-auto max-w-6xl px-4 py-10 text-center sm:px-6 sm:py-12">
          <a
            href="https://baseline.live"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 text-[9px] uppercase tracking-[0.25em] text-[#5b7788] transition hover:text-[#042133]"
          >
            Powered by
            <img src={baselineLogo} alt="Baseline logo" className="h-6 w-auto opacity-90" />
          </a>
        </div>
      </footer>
    </div>
  )
}
